import { useEffect } from "react";

const ALLOWED_HOSTNAMES = [
  "muzukuru.com",
  "www.muzukuru.com",
  "staging.muzukuru.com",
  "www.staging.muzukuru.com",
  "localhost",
  "127.0.0.1",
];

const TawkChat = () => {
  useEffect(() => {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname || "";

    // Only enable the chat on allowed hosts and referral-related pages
    const hostAllowed = ALLOWED_HOSTNAMES.includes(hostname);
    const pathAllowed = [
      "/referral",
      "/referral-program",
      "/referrals",
      "/referral-dashboard",
    ].some((p) => pathname.toLowerCase().startsWith(p));

    if (!hostAllowed || !pathAllowed) return;

    const src = "https://embed.tawk.to/6a5dc590aa83a11d48ca5257/default";

    // Prevent duplicate insertion
    if (document.querySelector(`script[src="${src}"]`)) return;

    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = src;
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript?.parentNode?.insertBefore(s1, firstScript);

    return () => {
      try {
        s1.parentNode?.removeChild(s1);
      } catch {
        // ignore
      }
    };
  }, []);

  return null;
};

export default TawkChat;
